import { defineStore } from 'pinia';
import { useNuxtApp } from "#app";
import { ProductCategoryCollectionType } from "~/types/shop/ProductCategoryCollectionType";
import * as qs from "qs";
import { ProductCategoryEntity } from "~/entities/shop/ProductCategoryEntity";

export const useProductCategoryCollectionStore = defineStore({
    id: 'useProductCategoryCollectionStore',
    state: (): ProductCategoryCollectionType => ({
        list: undefined,
        error: undefined,
    }),
    getters: {},
    actions: {
        async fetchList() {
            if (this.list !== undefined) {
                return true;
            }

            try {
                const query = {
                    fields: ['title', 'slug', 'svg_icon'],
                    sort: ['sorting:desc'],
                };
                const response = await useNuxtApp().axios.get(`/product-categories?${qs.stringify(query, {
                    encodeValuesOnly: true
                })}`);
                if (response?.data?.data === undefined) {
                    this.error = createError({ statusCode: 404, statusMessage: 'Page Not Found' });
                    return false;
                }

                if (!response?.data?.data.length) {
                    this.list = [];
                    this.error = 'There are no categories.';
                    return false;
                }

                this.list = response?.data?.data.map(item => ProductCategoryEntity(item));
                this.error = undefined;
            } catch (error) {
                console.log(error);
                this.error = createError({ statusCode: 500, statusMessage: 'Internal error' });
            }

            return true;
        }
    },
});
